import HeroSection from './components/HeroSection';
import DescriptionSection from './components/DescriptionSection';
import EngineeringPillars from './components/EngineeringPillars';
import InnovationStatement from './components/InnovationStatement';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main className="w-full min-w-[1024px] bg-background-50">
      <HeroSection />
      <DescriptionSection />
      <EngineeringPillars />
      <InnovationStatement />
      <ContactSection />
    </main>
  );
}